export default __webpack_public_path__ + "static/media/tablet-pos-img-ar.82ffce8a.png";